<template>
    <main class="content">
        <header class="content-header">
            <section class="content-header-section">
                <h1 class="content-header-title">{{ $t('pages.logs.list.title') }}</h1>
            </section>
        </header>
        <div class="content-top">
            <div class="content-top-date" v-click-outside="dateClose">
                <div class="content-top-date-value" @click="dateToggle">
                    <span v-if="period === '7_days'">7 days</span>
                    <span v-if="period === 'custom'">
                        Custom
                        ({{ formatDate(start) }} - {{ formatDate(end) }})
                    </span>
                </div>
                <div v-if="dateIsOpen" class="content-top-date-content">
                    <div class="date-title">Period of time</div>
                    <div class="date-option">
                        <label for="period_of_time_1" class="date-radio">
                            <input type="radio" id="period_of_time_1" name="period_of_time" value="7_days" v-model="form.period"/>
                            <span></span>
                            Last 7 days
                        </label>
                    </div>
                    <div class="date-option">
                        <label for="period_of_time_2" class="date-radio">
                            <input type="radio" id="period_of_time_2" name="period_of_time" value="custom" v-model="form.period"/>
                            <span></span>
                            Custom
                        </label>
                        <div class="date-list" v-if="form.period === 'custom'">
                            <div class="date-elem">
                                <div class="date-elem-label">Start date</div>
                                <div class="date-elem-calendar">
                                    <datepicker
                                        v-model="form.start"
                                        :input-class="{ error: error.start }"
                                        placeholder="Select date"
                                    />
                                </div>
                            </div>
                            <div class="date-elem">
                                <div class="date-elem-label">End date</div>
                                <div class="date-elem-calendar">
                                    <datepicker
                                        v-model="form.end"
                                        :input-class="{ error: error.end }"
                                        placeholder="Select date"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="date-footer">
                        <button class="date-cancel" @click="dateCancel">Cancel</button>
                        <button class="date-apply" @click="dateApply">Apply</button>
                    </div>
                </div>
            </div>
            <div class="content-top-count">{{ $t('components.list.label_count', { count }) }}</div>
        </div>
        <div class="content-data">
            <div
                v-for="item in list"
                :key="item.id"
                class="content-item"
            >
                <div class="content-item-value">
                    <span>
                        {{ formatDateTime(item.timestamp) }},
                        {{ item.username }}
                        (ID: {{ item.userid }}),
                        {{ formatAction(item.action) }},
                        {{ item.entitytype }}
                        (ID {{ item.id }})
                    </span>
                </div>
            </div>
        </div>

        <pagination
            :module="this.$options.module"
            :show-pages="this.$options.showPages"
            :payload="paginationPayload"
        />
    </main>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Pagination from '@/components/list/Pagination.vue';
import { formatDateTimeLogs } from '../utils/formatDate';

export default {
    name: 'Logs',
    module: 'logs',
    components: {
        Datepicker,
        Pagination,
    },
    showPages: 3,
    data() {
        return {
            dateIsOpen: false,
            period: '7_days',
            start: null,
            end: null,
            form: {
                period: '7_days',
                start: null,
                end: null,
            },
            error: {
                start: false,
                end: false,
            },
        };
    },
    computed: {
        list() {
            return this.$store.state[this.$options.module].list;
        },
        startServer() {
            return this.formatServerDateTime(this.start);
        },
        endServer() {
            return this.formatServerDateTime(this.end);
        },
        paginationPayload() {
            return {
                start: this.startServer,
                end: this.endServer,
            };
        },
        count() {
            return this.$store.state[this.$options.module].count;
        },
    },
    async created() {
        this.start = new Date();
        this.start.setDate(this.start.getDate() - 7);
        this.end = new Date();
    },
    methods: {
        dateClose() {
            this.dateIsOpen = false;
        },
        dateOpen() {
            this.dateIsOpen = true;
            this.form.period = this.period;
            this.form.start = this.start;
            this.form.end = this.end;
        },
        dateToggle() {
            return this.dateIsOpen ? this.dateClose() : this.dateOpen();
        },
        dateCancel() {
            this.dateClose();
        },
        dateApply() {
            this.error.start = false;
            this.error.end = false;
            if (this.form.period === 'custom') {
                if (!this.form.start) {
                    this.error.start = true;
                }
                if (!this.form.end) {
                    this.error.end = true;
                }
                if (this.form.start > this.form.end) {
                    this.error.start = true;
                    this.error.end = true;
                }
            }

            if (this.error.start === false && this.error.end === false) {
                this.dateClose();
                if (this.form.period === 'custom') {
                    this.period = this.form.period;
                    this.start = this.form.start;
                    this.end = this.form.end;
                } else {
                    this.period = this.form.period;
                    this.form.start = null;
                    this.form.end = null;

                    this.start = new Date();
                    this.start.setDate(this.start.getDate() - 7);
                    this.end = new Date();
                }

                this.$store.dispatch(`${ this.$options.module }/list`, {
                    page: 0,
                    start: this.startServer,
                    end: this.endServer,
                });
            }
        },
        formatDateTime: formatDateTimeLogs,
        formatDate(timestamp) {
            const d = new Date(timestamp);

            const year = d.getFullYear();
            const month = (d.getMonth() + 1).toString().padStart(2, '0');
            const day = d.getDate().toString().padStart(2, '0');

            return `${ year }-${ month }-${ day }`;
        },
        formatServerDateTime(d) {
            const year = d.getFullYear();
            const month = (d.getMonth() + 1).toString().padStart(2, '0');
            const day = d.getDate().toString().padStart(2, '0');

            return `${ year }-${ month }-${ day }T00:00:00Z`;
        },
        formatAction(action) {
            if (action === 1) {
                return 'deleted';
            }
            if (action === 0) {
                return 'created/updated';
            }
            return 'unknown';
        },
    },
};
</script>
